import { Injectable } from '@angular/core';
import { LangTgt } from '../../interfaces/lang-tgt';
import { WefitPartnerService } from '../wefit/wefit-partner.service';

@Injectable({
  providedIn: 'root'
})
export class AccessService {

  // Cache par code de langue (ex: 'zh', 'en', 'fr')
  private _cache = new Map<string, boolean>();

  constructor(private wefitPartnerSrv: WefitPartnerService) {}

  /**
   * Retourne true si l'utilisateur a un abonnement BOOST ou PRO
   * pour la langue cible demandée (formation_code = langCode).
   * Le résultat est mis en cache par langue.
   */
  async isPremium(langCode: string): Promise<boolean> {
    const key = langCode.toLowerCase();

    if (this._cache.has(key)) {
      return this._cache.get(key);
    }

    const tps = await this.wefitPartnerSrv.getTrainingPrograms();
    if (!tps) {
      this._cache.set(key, false);
      return false;
    }

    const isPremium = tps.some(
      tp =>
        tp.formation_code.toLowerCase() === key &&
        (tp.elearning_name === 'BOOST' || tp.elearning_name === 'PRO')
    );

    this._cache.set(key, isPremium);
    return isPremium;
  }

  /**
   * Retourne true si un niveau du parcours est verrouillé par le paywall.
   */
  isLevelPremiumLocked(levelIndex: number, langTgt: LangTgt, isPremium: boolean): boolean {
    if (!langTgt || langTgt.is_free) return false;
    if (isPremium) return false;
    return levelIndex >= (langTgt.nbFreeLevels ?? 0);
  }

  /**
   * Retourne true si les thèmes sont entièrement verrouillés par le paywall.
   */
  isThemePremiumLocked(langTgt: LangTgt, isPremium: boolean): boolean {
    if (!langTgt || langTgt.is_free) return false;
    return !isPremium;
  }

  /**
   * Réinitialise le cache (à appeler à la déconnexion).
   */
  reset(): void {
    this._cache.clear();
  }
}
